import { Check, Close } from "@mui/icons-material"
import { Box, Grid, Typography } from "@mui/material"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { IBatchItemReturn } from "../../../model/ItemModel"
import { BatchBackItem, BatchForwardItem } from "../../../services/ValidationRuleService"
import { KeyDriveButton } from "../../Button/KeyDriveButton/KeyDriveButton"
import { KeyDriveButtonStyles } from "../../Button/KeyDriveButton/types"
import { batchActionStates } from "../BatchActionModal"
import { style } from "../BatchTheme/tooltipTheme"
import { BatchActionBody } from "./BatchActionBody"
import { BatchActionHeader } from "./BatchActionHeader"

interface IBatchDefaultAction { 
    setOpen: (set: boolean) => void;
    handleChange: (event: React.SyntheticEvent, newValue: number) => void;
    approvedFiles: IBatchItemReturn[];
    reprovedFiles: IBatchItemReturn[];
    value: number;
    setBatchModalState: (set: batchActionStates) => void;
    refreshFunction: () => void;
}

export const BatchDefaultAction : React.FC<IBatchDefaultAction> = ({
    setOpen,
    handleChange,
    approvedFiles,
    reprovedFiles,
    value,
    setBatchModalState,
    refreshFunction
}) => {

    const { t } = useTranslation();
    const [loader, setLoader] = useState<{ approvedLoader: boolean, reprovedLoader: boolean }>({
        approvedLoader: false,
        reprovedLoader: false
    });

    const batchActionForward = () => {
        setLoader({
            ...loader,
            approvedLoader: true,
        });
        BatchForwardItem({
            items: approvedFiles.flatMap(x => x.id!)
        })
        .then(data => {
            setBatchModalState({
                default: false,
                approved: true,
                reproved: false
            })
        })
        .finally(() => {
            setLoader({
                ...loader,
                approvedLoader: false,
            });
            refreshFunction();
        })
      }
  
      const batchActionBack = () => {
        setLoader({
            ...loader,
            reprovedLoader: true,
        });
        BatchBackItem({
            items: approvedFiles.flatMap(x => x.id!),
        })
        .then(data => {
            setBatchModalState({
                default: false,
                approved: false,
                reproved: true
            })
        })
        .finally(() => {
            setLoader({
                ...loader,
                reprovedLoader: false,
            });
            refreshFunction();
        })
      }

    
    return (
        <Box sx={style}>
            <Grid
                container
            >
                <Grid
                    item
                    xs={12}
                    marginBottom="20px"
                >
                    <BatchActionHeader 
                        setOpen={setOpen}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                >
                    <BatchActionBody 
                        aprovedFiles={approvedFiles}
                        reprovedFiles={reprovedFiles}
                        handleChange={handleChange}
                        value={value}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    display="flex"
                    justifyContent="space-between"
                    marginTop="30px"
                >
                    <KeyDriveButton
                        KeyDriveButtonStyle={KeyDriveButtonStyles.DefaultStyles}
                        buttonContent={
                            <Typography
                                fontFamily="segoe ui"
                            >
                                {t("BatchActionModal.reproveButton")}
                            </Typography>
                        }
                        loader={loader.reprovedLoader}
                        startIcon={!loader.reprovedLoader && <Close />}
                        disabled={value == 1 || !(approvedFiles && approvedFiles.length > 0)}
                        onClick={batchActionBack}
                        KeyDriveButtonType="secondary"
                    />
                    <KeyDriveButton 
                        KeyDriveButtonStyle={KeyDriveButtonStyles.DefaultStyles}
                        buttonContent={
                            <Typography
                                fontFamily="segoe ui"
                            >
                                {t("BatchActionModal.aproveDocument")}
                            </Typography>
                        }
                        loader={loader.approvedLoader}
                        startIcon={!loader.approvedLoader && <Check />}
                        disabled={value == 1 || !(approvedFiles && approvedFiles.length > 0)}
                        onClick={batchActionForward}
                        KeyDriveButtonType="primary"
                    />
                </Grid>
            </Grid>
        </Box>
    )
}